import { Grid } from '@mui/material';
import { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import FiscalYeaCreateView from '../../../components/account/setup/fiscal_year/FiscalYeaCreateView';
import FiscalYearListView from '../../../components/account/setup/fiscal_year/FiscalYearListView';

const AcFiscalYearCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.AccountURL + 'account/fiscal/year/create/list/view/');

    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };

  return (
      <Fragment>
          <Grid container spacing={3}>
              <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                  <FiscalYeaCreateView handleFormSuccess={handleFormSuccess} />
              </Grid>
              <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                  <FiscalYearListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
              </Grid>
          </Grid>
      </Fragment>
  )
}

export default AcFiscalYearCreateListView